<script>
const module = {};
module.website = 'https://oa.lankuyun.com';
module.websiteTitle = '蓝库云';
module.websiteTitleTemplate = '%s - 蓝库云';

module.mainApiEndpoint = process.env.VUE_APP_MAIN_API_ENDPOINT;
module.version = process.env.VUE_APP_VERSION;
module.h5_url = process.env.VUE_APP_H5_URL;
// module.h5_url = "https://joa.cc:8081";

module.oidc = {
  pkce: true,
  grantType: 'authorization_code',
  issuer: `${process.env.VUE_APP_MAIN_PASS_URL}/auth/realms/yoov`,
  clientId: 'yoov-oa',
  realm: 'yoov',
  configUrl: `${process.env.VUE_APP_MAIN_PASS_URL}/auth`,
  redirectUri: `${process.env.VUE_APP_MAIN_REDIRECT_URL}/implicit/callback`,
  authorizeUrl: `${process.env.VUE_APP_MAIN_PASS_URL}/auth/realms/yoov/protocol/openid-connect/auth`,
  tokenUrl: `${process.env.VUE_APP_MAIN_PASS_URL}/auth/realms/yoov/protocol/openid-connect/token`,
  logoutUrl: `${process.env.VUE_APP_MAIN_PASS_URL}/auth/realms/yoov/protocol/openid-connect/logout`,
  responseType: 'code',
  scope: ['openid']
};

export default module;
</script>
